/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

export const getFseConsent = async () => (await api.get('/fse/consent')).data;
export const setFseConsent = async (granted) => (await api.post('/fse/consent', { granted })).data;
export const revokeFseConsent = async () => (await api.delete('/fse/consent')).data;

export const getFseDocTypes = async () => (await api.get('/fse/document-types')).data;

export const createFseDocument = async (payload) =>
  (await api.post('/fse/documents', payload)).data;

export const createFsePrescription = async (payload) =>
  (await api.post('/fse/prescription', payload)).data;

export const listFseDocuments = async ({ patientId = null, limit = 50, skip = 0 } = {}) => {
  const params = new URLSearchParams();
  if (patientId) params.set('patient_id', patientId);
  params.set('limit', String(limit));
  params.set('skip', String(skip));
  return (await api.get(`/fse/documents?${params.toString()}`)).data;
};

export const getFseDocument = async (docId) =>
  (await api.get(`/fse/documents/${docId}`)).data;

export const exportFseDocument = async (docId, reason = null) =>
  (await api.post(`/fse/documents/${docId}/export`, { reason })).data;

export const downloadFseDocumentXmlUrl = (docId) => {
  // Backend REACT_APP_BACKEND_URL is exposed via env; the /api prefix is
  // added by the ingress. We use a raw URL for anchor-based download so the
  // browser opens the file with proper Content-Disposition.
  const backend = process.env.REACT_APP_BACKEND_URL || '';
  return `${backend}/api/fse/documents/${docId}/xml`;
};

export const getFseAudit = async ({ limit = 50, skip = 0 } = {}) => {
  const params = new URLSearchParams();
  params.set('limit', String(limit));
  params.set('skip', String(skip));
  return (await api.get(`/fse/audit?${params.toString()}`)).data;
};
